import { useEffect } from 'react';

import useMemberRequirementData from '../../../state/member/memberRequirements/UsePersonRequirementsData';
import useMemberRequirements from '../../../views/member/memberRequirements/UseMemberRequirements';

const useMemberRequirementsFilterDropdown = () => {
  const { goodStandingData } = useMemberRequirements();
  const { memberRequirementState, setMemberRequirementState } = useMemberRequirementData();

  useEffect(() => {
    if (Array?.isArray(goodStandingData) === true && goodStandingData?.length > 0) {
      let newArray = [];
      goodStandingData?.forEach(type => {
        type?.goodStandingType?.forEach(goodStandingType => {
          const obj = newArray.find(x => x.name === goodStandingType?.goodStandingName);
          if (obj === undefined) {
            const goodStandingObj = {
              id: goodStandingType?.goodStandingId,
              name: goodStandingType?.goodStandingName
            }
            newArray.push(goodStandingObj)
          }
        })
      });

      setMemberRequirementState({ ...memberRequirementState, filteredRoleList: newArray })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [goodStandingData]);

  return {
    memberRequirementState
  }
};

export default useMemberRequirementsFilterDropdown;